/*
  ========================================================================
  File: assets/lm-product-accordions.js - one open disclosure at a time
  LAST UPDATED: 21/09/2026
  ========================================================================
  The product details rows are one group. Prestige's accordion-disclosure
  lets any number of rows stay open; this element makes the group exclusive:
  when a row opens, the row that was open closes. It closes rows through
  their own close(), so Prestige's animation and aria-expanded stay in
  charge, and it reacts to aria-expanded rather than to clicks, so a row
  opened by any other means (keyboard, theme editor block selection)
  behaves the same. Without JavaScript the rows are independent native
  disclosures.
  ========================================================================
*/

if (!customElements.get('lm-accordion-group')) {
  class LmAccordionGroup extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver((records) => {
        for (const record of records) {
          const details = record.target;
          if (details.getAttribute('aria-expanded') !== 'true') continue;

          const opened = details.closest('accordion-disclosure');
          for (const row of this.querySelectorAll('accordion-disclosure')) {
            if (row === opened) continue;
            const isOpen = row.querySelector('details')?.getAttribute('aria-expanded') === 'true';
            if (isOpen && typeof row.close === 'function') row.close();
          }
        }
      });
      this.observer.observe(this, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('lm-accordion-group', LmAccordionGroup);
}
